import CustomFilterContainer from "../../helpers/CustomFilterContainer";

class FreeSearchTextRules {
  constructor(param, filterObj, hasExistingParam) {
    this.param = param;
    this.maxRuleCount = 5;
    this.ruleCount = 0;
    this.filterObj = filterObj;
    this.paramValues = [];

    CustomFilterContainer.append(filterObj.label, param);
    this.parent = $(`#${param}`);

    this.#appendAddFilterGroupRuleButton();
    this.#addRuleButtonListener();

    if (hasExistingParam) {
      this.#initFilterGroupRules();
    } else {
      this.#appendCloseableInput();
    }
  }

  #appendAddFilterGroupRuleButton = () => {
    $(this.parent).append(
      `<button
         id="${this.param}-button"
         ${this.maxRuleCount === this.ruleCount ? 'disabled="true"' : ""}
         class="text-button">
        <span class="icon"><i class=\"fas fa-plus\"></i></span>
        ${this.filterObj.buttonText}
    </button>`
    );
  };

  #addRuleButtonListener = () => {
    $(`#${this.param}-button`).on("click", () => {
      this.#appendCloseableInput();
      this.#onFilterGroupRuleInputChange();

      if (this.ruleCount === this.maxRuleCount) {
        $(`#${this.param}-button`).attr("disabled", true);
      }
    });
  };

  #appendCloseableInput = () => {
    this.ruleCount += 1;
    this.paramValues.push({ id: this.ruleCount, value: "", include: true });

    $(`#${this.param}-input-container`).append(
      `<div class="closable-input-container">
        <input id="${this.param}-${this.ruleCount}" placeholder="${this.filterObj.placeholder}" class="text-input">
        </input>
        <select id="exclude-select-${this.param}-${this.ruleCount}" value="include">
          <option value="include">Szerepel</option>
          <option value="exclude">Nem szerepel</option>
        </select>
        <button id="${this.param}-${this.ruleCount}-close" class="input-button">
          <span>
            <i class="fas fa-times close-icon"></i>
          </span>
        </button>
      </div>`
    );

    $(`#exclude-select-${this.param}-${this.ruleCount}`).selectmenu();

    this.removeFilterRuleListener(this.ruleCount);
    this.#onFilterGroupRuleInputChange(this.ruleCount);
    this.#onExcludeSelectChange(this.ruleCount);
  };

  removeFilterRuleListener(ruleCount) {
    $(`#${this.param}-${ruleCount}-close`).on("click", () => {
      $(`#${this.param}-${ruleCount}-close`).parent().remove();
      $(`#${this.param}-button`).attr("disabled", false);

      this.removeParam(ruleCount);
      this.setParams();

      this.ruleCount -= 1;

      // check if there is no input left, remove filter group
      if (this.ruleCount === 0) {
        $(`#${this.param}`).remove();
        // enable add filter button
        this.filterObj.isApplied = false;
        $("#add-filter-button").attr("disabled", false);
      }
    });
  }

  #onFilterGroupRuleInputChange(ruleCount) {
    $(`#${this.param}-${ruleCount}`).on("input", (e) => {
      const value = e.target.value;

      const currentParam = this.paramValues.find(
        (param) => param.id === ruleCount
      );
      currentParam.value = value;

      this.setParams();
    });
  }

  #onExcludeSelectChange(ruleCount) {
    $(`#exclude-select-${this.param}-${ruleCount}`).on("selectmenuchange", (e) => {
      const value = e.target.value;
      const currentParam = this.paramValues.find(
        (param) => param.id === ruleCount
      );
      currentParam.include = value === "include";

      this.setParams();
    });
  }

  setParams() {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.delete(this.param);

    //avoid setting empty params
    const hasParams = this.paramValues.some((param) => param.value !== "");

    if (hasParams) {
      const currentParams = this.paramValues
        .filter((param) => param.value !== "")
        .map((param) => `${param.include ? "" : "!"}${param.value}`);
      const stringifyParams = JSON.stringify(currentParams);

      searchParams.set(this.param, stringifyParams);
    }

    window.history.replaceState(
      {},
      "",
      `${window.location.pathname}?${searchParams}`
    );
  }

  removeParam(id) {
    this.paramValues = this.paramValues.filter((param) => param.id !== id);
    this.setParams();
  }

  // init filter group rules from params on first load
  #initFilterGroupRules() {
    const searchParams = new URLSearchParams(window.location.search);
    const existingParam = searchParams.get(this.param);
    const parsedParams = JSON.parse(existingParam);

    parsedParams.forEach((value) => {
      this.ruleCount++;
      const include = !value.startsWith("!");
      this.paramValues.push({
        id: this.ruleCount,
        value: include ? value : value.substring(1),
        include,
      });

      $(`#${this.param}-input-container`).append(
        `<div class="closable-input-container">
        <input id="${this.param}-${this.ruleCount}" placeholder="${
          this.filterObj.placeholder
        }" class="text-input">
        </input>
        <select id="exclude-select-${this.param}-${this.ruleCount}">
          <option value="include" ${include ? "selected" : ""}>
        Szerepel
      </option>
      <option value="exclude" ${include ? "" : "selected"}>
        Nem szerepel
      </option>
        </select>
        <button id="${this.param}-${this.ruleCount}-close" class="input-button">
          <span>
            <i class="fas fa-times close-icon"></i>
          </span>
        </button>
      </div>`
      );

      $(`#exclude-select-${this.param}-${this.ruleCount}`).selectmenu();

      $(`#${this.param}-${this.ruleCount}`).val(
        include ? value : value.substring(1)
      );

      this.removeFilterRuleListener(this.ruleCount);
      this.#onFilterGroupRuleInputChange(this.ruleCount);
      this.#onExcludeSelectChange(this.ruleCount);
    });
  }
}

export default FreeSearchTextRules;
